import React from "react";
import "./ReportsNav.less";

class ReportsTableNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultReport: props.defaultReport,
      navLinks: [],
      reportsNavList: props.reportsNavList
    };
  }

  componentDidMount() {
    const { reportsNavList } = this.state;
    const navLinks = reportsNavList.filter(x => {
      return x;
    });
    this.setState({
      navLinks: navLinks,
      defaultReport: (navLinks[0] || {}).ReportDisplayName
    });
    this.props.onNavClick((navLinks[0] || {}).ReportDisplayName);
  }

  /**
   * set value of active report title
   * @param {*} reportTitle
   */
  activeReport = reportTitle => {
    this.setState({ defaultReport: reportTitle });
    this.props.onNavClick(reportTitle);
  };

  render() {
    const WidthStyle = "calc(100%/" + this.state.navLinks.length + ")";
    return (
      <>
        <div className={"reportingNav-wrapper"}>
          {(this.state.navLinks || []).map((item, index) => (
            <div
              key={"ReportNavButtons" + index}
              className={
                this.state.defaultReport == item.ReportDisplayName
                  ? "navReport-element navReport-element-active"
                  : "navReport-element navReport-element-normal"
              }
              style={{ width: WidthStyle }}
              onClick={() => this.activeReport(item.ReportDisplayName)}
            >
              {item.ReportDisplayName}{" "}
            </div>
          ))}
        </div>
      </>
    );
  }
}

export default ReportsTableNav;
